import React from 'react';

const LeaderboardMoversExtendedIcon = ({ stateIcon }) => {
    return (
        <div className={`leaderboard__cell-icon-more-wrapper ${stateIcon}`}>
            <svg className="leaderboard__cell-icon-more icon" width="9" height="6" focusable="false">
                <use xlinkHref="#icon-triangle"></use>
            </svg>
            <svg className="leaderboard__cell-icon-more icon" width="9" height="6" focusable="false">
                <use xlinkHref="#icon-triangle"></use>
            </svg>
            <svg className="leaderboard__cell-icon-more icon" width="9" height="6" focusable="false">
                <use xlinkHref="#icon-triangle"></use>
            </svg>
        </div>
    );
};

export default LeaderboardMoversExtendedIcon;
